import styled from 'styled-components';

export const CursiveMessage = styled.p`
	font-family: 'Quicksand', sans-serif;
	font-size: 1.1rem;
	font-style: italic;
	text-align: center;
	margin-top: 0.75rem;
	margin-bottom: 0;
	color: #6c757d;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
`;
